import { PosAbsolute, PosRelative } from '@layout/BuildingBlocks'
import React from 'react'

export const HandshakeIcon = ({
  size = 32,
  width,
  iconColor = '#4C4D4C',
  backgroundColor = '#69BEB1',
  strokeWidth,
  shadow = true,
}) => {
  return (
    <PosRelative width={width || size} height="100%">
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15.5" cy="13.5" r="12.5" fill={backgroundColor} />
        </svg>
      </PosAbsolute>
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ filter: shadow && 'drop-shadow(0 5px 3px #bfbfbf)' }}
        >
          <path
            d="M29.3911 8.50003H25.4987C25.3785 8.50027 25.261 8.46371 25.1612 8.39503L21.8158 6.105C21.7158 6.03653 21.5983 6 21.4781 6H17.8259C17.7412 6.00009 17.6573 6.01832 17.5798 6.05353C17.5022 6.08874 17.4326 6.14016 17.3755 6.2045L15.3425 8.50003H9.67279C9.31222 8.4996 8.95966 8.60924 8.65992 8.81503L5.62122 10.8952C5.52136 10.9639 5.40383 11.0004 5.28364 11.0002H2.60869C2.44726 11.0002 2.29243 11.066 2.17828 11.1832C2.06413 11.3005 2 11.4594 2 11.6252V20.3753C2 20.5411 2.06413 20.7 2.17828 20.8173C2.29243 20.9345 2.44726 21.0003 2.60869 21.0003H7.63513C7.77696 20.9992 7.91448 21.0502 8.02275 21.1443C8.19391 21.2943 8.42692 21.5154 8.70752 21.7818C10.131 23.2363 11.7318 24.4955 13.47 25.5282C14.0665 25.839 14.726 26.0006 15.3948 26C15.9889 26.0001 16.5766 25.874 17.1209 25.6294C17.6651 25.3849 18.1542 25.0273 18.5572 24.5791L22.5768 19.7252C22.6154 19.7378 22.6553 19.7462 22.6957 19.7502H29.3913C29.5527 19.7502 29.7076 19.6843 29.8217 19.5671C29.9359 19.4499 30 19.2909 30 19.1252V9.12504C30 9.04294 29.9842 8.96165 29.9536 8.8858C29.923 8.80995 29.8782 8.74104 29.8216 8.683C29.7651 8.62496 29.698 8.57893 29.6241 8.54754C29.5502 8.51614 29.471 8.5 29.3911 8.50003ZM22.3839 18.0295L17.6464 23.7505C17.1933 24.2495 16.5946 24.5839 15.9405 24.7034C15.2863 24.8228 14.6121 24.7209 14.0192 24.413C12.3838 23.4304 10.8769 22.2379 9.53486 20.8643C9.23769 20.5823 8.99154 20.3479 8.80966 20.1904C8.48126 19.9055 8.06508 19.7494 7.63513 19.7498H3.21738V12.2497H5.28364C5.64421 12.2501 5.99676 12.1405 6.2965 11.9347L9.33521 9.85505C9.43507 9.78637 9.5526 9.74981 9.67279 9.75005H14.2364L12.4191 11.8027C12.0021 12.273 11.7809 12.8921 11.8028 13.5277C11.8247 14.1632 12.0879 14.7648 12.5361 15.2037C12.9844 15.6426 13.5821 15.8839 14.2014 15.8762C14.8207 15.8684 15.4125 15.6121 15.8501 15.1621L18.9926 11.9357L22.4566 16.3815C22.6415 16.6184 22.736 16.9163 22.7226 17.2196C22.7093 17.5228 22.5889 17.8107 22.3839 18.0295V18.0295ZM28.7824 18.5002H23.5636C23.837 18.0612 23.9691 17.545 23.9411 17.0247C23.9131 16.5044 23.7264 16.0063 23.4075 15.601L19.5188 10.6094C19.4639 10.5433 19.3967 10.4891 19.3211 10.45C19.2454 10.411 19.163 10.3879 19.0785 10.3821C19.0382 10.3812 18.9979 10.3846 18.9582 10.3922C18.8295 10.4108 18.7092 10.4686 18.6129 10.5582L14.9895 14.2784C14.7767 14.4982 14.4885 14.6237 14.1867 14.6278C13.8848 14.632 13.5934 14.5145 13.375 14.3006C13.1566 14.0867 13.0285 13.7934 13.0182 13.4837C13.008 13.1739 13.1164 12.8723 13.3202 12.6437L18.0946 7.25002H21.2938L24.4859 9.43504C24.7856 9.64083 25.1382 9.75048 25.4987 9.75005H28.7824V18.5002Z"
            fill={iconColor}
            stroke={iconColor}
            strokeWidth={strokeWidth}
          />
        </svg>
      </PosAbsolute>
    </PosRelative>
  )
}
